import { useNavigate, useParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { usePointBasedGrid, usePointBasedGridUpdateMutation } from "src/hooks";
import { useCase } from "src/hooks/useCase";
import { PointBasedGridMutationData } from "src/hooks/grids";
import { PointBasedGridForm } from "src/forms/PointBasedGridForm";
import { Pane } from "src/components/Pane";
import { isReadOnly } from "src/utils/permission.utils";
import { Spacer } from "src/components/Spacer";
import { ButtonDocs } from "src/components/ButtonDocs";

interface Props {}

export function PointBasedGridPage(props: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { caseId = "" } = useParams<{ caseId: string }>();
  const { data: acase } = useCase(caseId);
  const { data: pointBasedGrid } = usePointBasedGrid(caseId);

  const updatePointBasedGridMutation = usePointBasedGridUpdateMutation(caseId);

  /**
   * Functions
   */
  function handleSubmit(values: PointBasedGridMutationData) {
    updatePointBasedGridMutation.mutateAsync(values).then(() => handleClose());
  }

  function handleClose() {
    navigate(`/cases/${caseId}/grid-settings`);
  }

  return render();

  function render() {
    if (!pointBasedGrid || !acase) return null;

    return (
      <StyledPane>
        <PointBasedGridForm
          data={pointBasedGrid}
          isLoading={updatePointBasedGridMutation.isLoading}
          errors={updatePointBasedGridMutation.error?.response?.data}
          readOnly={isReadOnly(acase.permissions.updatePointBasedGrid)}
          onSubmit={handleSubmit}
          onClose={handleClose}
        />

        <Spacer />

        <ButtonDocs docsPath="/tutorial/case/case-grid-settings">{t("label.moreInfoAboutGrid")}</ButtonDocs>
      </StyledPane>
    );
  }
}

const StyledPane = styled(Pane)``;
